import React, { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FindLoad, SendPageSave, useGlobalStyles, FindSuccessItem, getSkipCount } from 'utils';
import { Loader, NoItemsYet } from 'components';
import { tableStyle } from '../table/styles';
import { PaginationFillTable } from '../pagination';
import { SearchAndFilerFull } from './searchAndFilerFull';

export const FullTable = ({
    head,
    body,
    list,
    loadingType,
    handleClick,
    noText,
    margin,
    listCount,
    handleClickButton,
    activeRowId,
    selectedList,
    selectAllList,
    height,
    generateTable,
    renderBorder,
    renderRowStyle,
    notYet,
    detailPage,
    getParams,
    savedParams,
    accordionBody,
    containerStyles = {},
    minWidth = 1200,
}) => {
    const classes = tableStyle();
    const globalStyle = useGlobalStyles();
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const loader = FindLoad(loadingType ? loadingType : '');
    const miniLoadSuccess = FindSuccessItem('MINI_LOAD');
    const downloadMiniLoadSuccess = FindSuccessItem('MINI_LOAD_DOWNLOAD');
    const [listInfo, setListInfo] = useState(list);
    const [searched, setSearched] = useState({ name: '', text: '' });

    useEffect(() => {
        if (list && !searched?.value) {
            setListInfo(list);
        }
    }, [list]);

    useEffect(() => {
        if (info?.page && !getParams) {
            setPage(info?.page);
        }
    }, [info]);

    const changePage = (number) => {
        setPage(number);
        setSearched({ name: '', text: '' });

        if (getParams) {
            const _skip = getSkipCount(number, 50);
            const pushInfo = { ...info };
            pushInfo.page = number;
            pushInfo.skip = _skip;
            getParams(pushInfo);
        } else {
            SendPageSave(number, info, navigate);
        }
    };

    const handleName = (item, name) => {
        handleClickButton && handleClickButton(item, name);
    };

    const renderItems = (i, item, index) => {
        if (item?.button) {
            return item?.button(
                (name) => handleName(i, name),
                i,
                miniLoadSuccess?.data === i.id || i.staffId,
                downloadMiniLoadSuccess?.data === i?.id
            );
        } else {
            return item?.rowText(i, index);
        }
    };

    return (
        <div style={margin ? { margin: margin } : {}} className={globalStyle.tableWrapper}>
            <TableContainer
                style={{ padding: '0 2px', ...containerStyles }}
                className={`${
                    height === 'extraSmall'
                        ? globalStyle.tableContainerExtraSmall
                        : height === 'auto'
                          ? globalStyle.tableContainerAutoHeight
                          : height === 'small'
                            ? globalStyle.tableContainerSmallHeight
                            : height === 'medium'
                              ? globalStyle.tableContainerMediumHeight
                              : globalStyle.tableContainer
                } ${globalStyle.tableHorizontalScroll}`}
                component={Paper}
            >
                <Table
                    stickyHeader
                    // aria-label="sticky table"
                    className={globalStyle.table}
                    style={{ position: 'relative', minWidth }}
                    size="small"
                    aria-label="sticky table"
                    // aria-label="a dense table"
                >
                    <TableHead
                        className={
                            accordionBody ? classes.accordionTableHead : generateTable ? classes.tableHeadGenerate : classes.tableHead
                        }
                    >
                        <TableRow>
                            {head
                                ? head.map(
                                      (i, j) =>
                                          i && (
                                              <TableCell key={j} style={i?.width ? { width: i.width } : {}}>
                                                  {i?.renderView ? (
                                                      <div>{i?.renderView}</div>
                                                  ) : (
                                                      <SearchAndFilerFull
                                                          setListInfo={setListInfo}
                                                          list={list}
                                                          item={i}
                                                          page={page}
                                                          searched={searched}
                                                          setSearched={setSearched}
                                                          generateTable={generateTable}
                                                          getParams={getParams}
                                                          savedParams={savedParams}
                                                      />
                                                  )}
                                              </TableCell>
                                          )
                                  )
                                : ''}
                        </TableRow>
                    </TableHead>

                    {loader?.length ? (
                        <div style={{ position: 'absolute', width: '100%' }}>
                            <Loader
                                styles={{
                                    ...containerStyles,
                                    height: containerStyles?.height
                                        ? `calc(${containerStyles?.height} - 84px)`
                                        : height === 'medium'
                                          ? '50vh'
                                          : '70vh',
                                    maxHeight: containerStyles?.maxHeight ? `calc(${containerStyles?.maxHeight} - 84px)` : '',
                                }}
                            />
                        </div>
                    ) : (
                        <TableBody>
                            {listInfo?.length ? (
                                listInfo?.map((i, j) => (
                                    <React.Fragment key={j}>
                                        <TableRow
                                            style={renderRowStyle ? { ...renderRowStyle(i) } : {}}
                                            className={
                                                accordionBody
                                                    ? classes.generateAccordionTableRow
                                                    : generateTable
                                                      ? classes.generateTableRow
                                                      : [
                                                            classes.tableRow,
                                                            i.id === activeRowId ? 'active' : '',
                                                            selectAllList || selectedList?.includes(i.id) ? 'selected' : '',
                                                        ]
                                                            .filter(Boolean)
                                                            .join(' ')
                                            }
                                        >
                                            {body?.map((item, ke) => {
                                                if (item) {
                                                    return (
                                                        <Fragment key={ke}>
                                                            <TableCell
                                                                className={classes.customRow}
                                                                // onClick={() => item?.notClickable !== true && handleClick && handleClick(i?.id || i?._id, i)}
                                                                onClick={(e) => {
                                                                    if (window.getSelection().toString()) return; // Prevent action on text selection
                                                                    if (item?.notClickable !== true && handleClick) {
                                                                        handleClick(i?.id || i?._id, i);
                                                                    }
                                                                }}
                                                                style={
                                                                    renderBorder
                                                                        ? { ...renderBorder(i) }
                                                                        : item?.padding === '0'
                                                                          ? { padding: 0 }
                                                                          : item?.background
                                                                            ? { background: item?.background }
                                                                            : {}
                                                                }
                                                            >
                                                                {detailPage && detailPage(i) ? (
                                                                    <Link
                                                                        onClick={(e) => {
                                                                            if (
                                                                                item?.notClickable === true ||
                                                                                window.getSelection().toString()
                                                                            ) {
                                                                                e.preventDefault();
                                                                                e.stopPropagation();
                                                                            }
                                                                        }}
                                                                        to={item?.notClickable === true ? '#' : detailPage(i)}
                                                                        style={{ all: 'unset', cursor: 'pointer' }}
                                                                    >
                                                                        {renderItems(i, item, j) || '--'}
                                                                    </Link>
                                                                ) : (
                                                                    renderItems(i, item, j) || '--'
                                                                )}
                                                            </TableCell>
                                                        </Fragment>
                                                    );
                                                }
                                            })}
                                        </TableRow>
                                    </React.Fragment>
                                ))
                            ) : (
                                <>
                                    {notYet ? (
                                        <NoItemsYet
                                            height={notYet?.height}
                                            text={notYet.title}
                                            subTitle={notYet.subTitle}
                                            image={notYet.image}
                                            containerStyles={
                                                height === 'auto'
                                                    ? { padding: '20px 0' }
                                                    : containerStyles
                                                      ? {
                                                            ...containerStyles,
                                                            height: `calc(${containerStyles?.height} - 84px)`,
                                                            maxHeight: `calc(${containerStyles?.maxHeight} - 84px)`,
                                                        }
                                                      : {}
                                            }
                                        />
                                    ) : (
                                        <NoItemsYet
                                            text={`No ${noText} yet`}
                                            containerStyles={height === 'auto' ? { padding: '20px 0' } : {}}
                                        />
                                    )}
                                </>
                            )}
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
            {listCount > 0 && (
                <div style={{ height: '76px' }}>
                    <PaginationFillTable
                        listLength={listInfo?.length}
                        page={page}
                        handleReturn={(number) => changePage(number)}
                        count={listCount}
                    />
                </div>
            )}
        </div>
    );
};
